/**
 * cart-drawer.js — assets/
 * <script src="{{ 'cart-drawer.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     KONFIGURATION
  ───────────────────────────────────────────── */
  var Config = {
    // Fri frakt-tröskel i ören (79900 = 799 kr)
    freeShippingThreshold: 79900,

    // Valutasymbol
    currency: 'kr',

    // Upsell product handles — hämtas via /products/[handle].js
    // Ordningen här = ordningen i slidern (första visas först)
    upsellHandles: [
      'srixon-soft-feel-vit',
      'wilson-duo-soft-vit',
      'srixon-z-star-vit',
      'wilson-staff-model-trk360-vit',
      'wilson-staff-model-vit',
      'wilson-staff-model-x-vit',
      'srixon-all-weather-microfiber-glove'
    ],

    // Shipping-bar meddelande
    shippingMessage: 'Du har {amount} kvar till Fri frakt!',
  };

  /* ─────────────────────────────────────────────
     PENGAR
  ───────────────────────────────────────────── */
  function formatMoney(cents) {
    return Math.round(cents / 100) + '\u00a0' + Config.currency;
  }

  /* ─────────────────────────────────────────────
     SHOPIFY AJAX CART API
  ───────────────────────────────────────────── */
  var CartAPI = {
    get: function () {
      return fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' }
      }).then(function (r) { return r.json(); });
    },
    add: function (variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    },
    change: function (line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty }),
      }).then(function (r) { return r.json(); });
    },
  };

  /* ─────────────────────────────────────────────
     CART DRAWER
  ───────────────────────────────────────────── */
  var Drawer = {
    isOpen: false,
    upsellProducts: [],
    upsellIndex: 0,

    el: null,
    overlay: null,
    itemsEl: null,
    totalEl: null,
    shippingText: null,
    shippingFill: null,
    shippingReached: null,
    upsellSection: null,
    upsellTrack: null,

    init: function () {
      this.el              = document.getElementById('cart-drawer');
      this.overlay         = document.getElementById('cart-overlay');
      this.itemsEl         = document.getElementById('cart-items-container');
      this.totalEl         = document.getElementById('cart-total-price');
      this.shippingText    = document.getElementById('cart-shipping-text');
      this.shippingFill    = document.getElementById('cart-shipping-fill');
      this.shippingReached = document.getElementById('cart-shipping-reached');
      this.upsellSection   = document.getElementById('cart-upsell-section');
      this.upsellTrack     = document.getElementById('cart-upsell-track');

      if (!this.el) return;

      this._bindStatic();
      this._interceptForms();
      this._patchFetch();
      this._loadUpsells();
    },

    /* ── Static bindings ── */
    _bindStatic: function () {
      var self = this;

      document.getElementById('cart-drawer-close').addEventListener('click', function () { self.close(); });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.getElementById('cart-continue-btn').addEventListener('click', function () { self.close(); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      // Intercept /cart-links i header
      document.querySelectorAll('a[href="/cart"]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      // Upsell-pilar
      document.getElementById('upsell-prev').addEventListener('click', function () {
        self._upsellTo(self.upsellIndex - 1);
      });
      document.getElementById('upsell-next').addEventListener('click', function () {
        self._upsellTo(self.upsellIndex + 1);
      });
    },

    /* ── Intercept native forms ──
       Bara preventDefault på form submit så sidan inte navigerar till /cart.
       Empire's click-handler och fetch-anrop får köra ostört.
       Vi lägger ALDRIG till produkten själva härifrån.
    ── */
    _interceptForms: function () {
      /* Stoppar bara hård page-redirect. Empire's JS kör ostört. */
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form.matches('[action*="/cart/add"]')) return;
        e.preventDefault();
      });
    },

    /* Empire använder XMLHttpRequest (inte fetch) för cart/add.
       Vi patchar XHR + fetch med debounce så drawern öppnas en gång per klick. */
    _patchFetch: function () {
      var self          = this;
      var debounceTimer = null;

      function onCartAdd() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          self._hideEmpireBanner();
          self.refreshAndOpen();
        }, 400);
      }

      /* ── Patch XMLHttpRequest ── */
      var OrigXHR = window.XMLHttpRequest;
      function PatchedXHR() {
        var xhr     = new OrigXHR();
        var _method = '';
        var _url    = '';
        var _origOpen = xhr.open.bind(xhr);
        var _origSend = xhr.send.bind(xhr);

        xhr.open = function (method, url) {
          _method = (method || '').toUpperCase();
          _url    = url || '';
          return _origOpen.apply(xhr, arguments);
        };

        xhr.send = function () {
          if (_method === 'POST' && _url.indexOf('/cart/add') !== -1) {
            xhr.addEventListener('load', function () {
              if (xhr.status >= 200 && xhr.status < 300) onCartAdd();
            });
          }
          return _origSend.apply(xhr, arguments);
        };

        return xhr;
      }
      PatchedXHR.prototype = OrigXHR.prototype;
      window.XMLHttpRequest = PatchedXHR;

      /* ── Patch fetch (säkerhetsnät) ── */
      var origFetch = window.fetch;
      window.fetch  = function (url) {
        var args = arguments;
        return origFetch.apply(this, args).then(function (res) {
          if (
            typeof url === 'string' &&
            url.indexOf('/cart/add') !== -1 &&
            args[1] &&
            (args[1].method || '').toUpperCase() === 'POST' &&
            res.ok
          ) { onCartAdd(); }
          return res;
        });
      };

      /* ── MutationObserver: stäng ATC-banner direkt ── */
      var existingBanner = document.querySelector('[data-atc-banner]');
      if (existingBanner && window.MutationObserver) {
        new MutationObserver(function () {
          if (existingBanner.getAttribute('data-animation-state') === 'open') {
            self._hideEmpireBanner();
          }
        }).observe(existingBanner, { attributes: true, attributeFilter: ['data-animation-state'] });
      }
      if (window.MutationObserver) {
        new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var nodes = mutations[i].addedNodes;
            for (var j = 0; j < nodes.length; j++) {
              var n = nodes[j];
              if (n.nodeType !== 1) continue;
              if ((n.hasAttribute && n.hasAttribute('data-atc-banner')) ||
                  (n.querySelector && n.querySelector('[data-atc-banner]'))) {
                self._hideEmpireBanner();
              }
            }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
    },

    _hideEmpireBanner: function () {
      var banner = document.querySelector('[data-atc-banner]');
      if (banner) {
        banner.setAttribute('data-animation-state', 'closed');
        banner.setAttribute('aria-hidden', 'true');
      }
      var closeBtn = document.querySelector('[data-atc-banner-close]');
      if (closeBtn) closeBtn.click();
    },

    _addThenOpen: function (variantId, qty) {
      var self = this;
      CartAPI.add(variantId, qty).then(function () {
        self._hideEmpireBanner();
        self.refreshAndOpen();
      }).catch(function (err) {
        console.error('[CartDrawer] add failed:', err);
      });
    },

    /* ── Open / close ── */
    open: function () {
      var self = this;
      this.refresh().then(function () {
        self.el.classList.add('is-open');
        self.overlay.classList.add('is-open');
        self.el.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        self.isOpen = true;
        /* Inget .focus() — Empire's theme-a11y.js kraschar annars */
      });
    },

    close: function () {
      this.el.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.isOpen = false;
    },

    refreshAndOpen: function () {
      if (this.isOpen) { this.refresh(); } else { this.open(); }
    },

    refresh: function () {
      var self = this;
      return CartAPI.get().then(function (cart) {
        self._render(cart);
        self._updateBubble(cart.item_count);
      });
    },

    /* ── Render ── */
    _render: function (cart) {
      this._renderItems(cart);
      this._renderTotal(cart);
      this._renderShipping(cart);
    },

    /* ── Items ── */
    _renderItems: function (cart) {
      var self  = this;
      var tmpl  = document.getElementById('cart-item-template');
      this.itemsEl.innerHTML = '';

      if (!cart.items || cart.items.length === 0) {
        this.itemsEl.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<svg width="44" height="44" viewBox="0 0 24 24" fill="none">' +
          '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
          '<line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="1.4"/>' +
          '</svg><p>Din varukorg är tom</p></div>';
        return;
      }

      cart.items.forEach(function (item, idx) {
        var lineIndex = idx + 1;
        var node = tmpl.content.cloneNode(true);
        var el   = node.querySelector('.cart-item');

        el.dataset.lineIndex = lineIndex;

        var img = el.querySelector('.cart-item__image');
        img.src = item.image || '';
        img.alt = item.product_title || '';
        el.querySelector('.cart-item__image-wrap').href = item.url || '/products/' + item.handle;

        var titleEl = el.querySelector('.cart-item__title');
        titleEl.textContent = item.product_title || '';
        titleEl.href = item.url || '/products/' + item.handle;

        el.querySelector('.cart-item__price').textContent = formatMoney(item.final_line_price);
        el.querySelector('.cart-item__qty-value').textContent = item.quantity;

        self._buildCartItemSelects(el, item, lineIndex);

        el.querySelector('.cart-item__qty-minus').addEventListener('click', function () {
          self._changeQty(el, lineIndex, item.quantity - 1);
        });
        el.querySelector('.cart-item__qty-plus').addEventListener('click', function () {
          self._changeQty(el, lineIndex, item.quantity + 1);
        });
        el.querySelector('.cart-item__remove').addEventListener('click', function () {
          self._changeQty(el, lineIndex, 0);
        });

        var badge = el.querySelector('.cart-item__badge');
        if (item.properties && item.properties['_badge']) {
          badge.textContent   = item.properties['_badge'];
          badge.style.display = 'inline-block';
        }

        self.itemsEl.appendChild(node);
      });
    },

    /* ── Variant selects for cart items ── */
    _buildCartItemSelects: function (el, item, lineIndex) {
      var self        = this;
      var labelEl     = el.querySelector('.cart-item__variant-label');
      var selectsWrap = el.querySelector('.cart-item__selects');

      if (!item.variant_title || item.variant_title === 'Default Title') return;

      // Visa variant title som plain text direkt (fallback)
      labelEl.textContent    = item.variant_title;
      labelEl.style.display  = 'block';

      fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var optionNames = product.options.map(function (o) { return o.name; });
          labelEl.textContent = optionNames.join(', ') + ':';

          var currentVariant = product.variants.find(function (v) { return v.id === item.variant_id; });
          if (!currentVariant) return;

          selectsWrap.innerHTML = '';

          product.options.forEach(function (option, optIdx) {
            var select = document.createElement('select');
            select.className = 'cart-item__select';
            select.setAttribute('aria-label', option.name);

            var values = [];
            product.variants.forEach(function (v) {
              var val = v['option' + (optIdx + 1)];
              if (values.indexOf(val) === -1) values.push(val);
            });

            values.forEach(function (val) {
              var opt = document.createElement('option');
              opt.value = val;
              opt.textContent = val;
              if (currentVariant['option' + (optIdx + 1)] === val) opt.selected = true;
              select.appendChild(opt);
            });

            select.addEventListener('change', function () {
              var allSelects   = selectsWrap.querySelectorAll('.cart-item__select');
              var selectedOpts = Array.from(allSelects).map(function (s) { return s.value; });
              var match = product.variants.find(function (v) {
                return product.options.every(function (_, i) {
                  return v['option' + (i + 1)] === selectedOpts[i];
                });
              });
              if (!match || !match.available) return;

              el.classList.add('cart-item--loading');
              CartAPI.change(lineIndex, 0)
                .then(function () { return CartAPI.add(match.id, item.quantity); })
                .then(function () { self.refresh(); })
                .catch(function () { el.classList.remove('cart-item--loading'); });
            });

            selectsWrap.appendChild(select);
          });
        })
        .catch(function () { /* keep plain text fallback */ });
    },

    /* ── Qty change / remove ── */
    _changeQty: function (el, lineIndex, newQty) {
      var self = this;
      if (newQty < 0) return;
      el.classList.add('cart-item--loading');
      CartAPI.change(lineIndex, newQty).then(function (cart) {
        self._render(cart);
        self._updateBubble(cart.item_count);
      }).catch(function () {
        el.classList.remove('cart-item--loading');
      });
    },

    /* ── Total ── */
    _renderTotal: function (cart) {
      this.totalEl.textContent = formatMoney(cart.total_price);
    },

    /* ── Shipping bar — inga ikoner, bara text + progress ── */
    _renderShipping: function (cart) {
      var threshold = Config.freeShippingThreshold;
      var remaining = threshold - cart.total_price;
      var pct       = Math.min((cart.total_price / threshold) * 100, 100);

      this.shippingFill.style.width = pct + '%';

      if (remaining <= 0) {
        this.shippingText.style.display    = 'none';
        this.shippingReached.style.display = 'block';
      } else {
        this.shippingText.style.display    = 'block';
        this.shippingReached.style.display = 'none';
        // Byt ut {amount} och gör beloppet fetstilt
        var amount  = formatMoney(remaining);
        var message = Config.shippingMessage.replace('{amount}', '<strong>' + amount + '</strong>');
        this.shippingText.innerHTML = message;
      }
    },

    /* ── Header cart bubble ── */
    _updateBubble: function (count) {
      document.querySelectorAll(
        '[data-cart-count], .cart-count, .cart-link__bubble, .cart__count, #CartCount, .cart-count-bubble'
      ).forEach(function (el) {
        el.textContent  = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    },

    /* ── Upsells ── */
    _loadUpsells: function () {
      var self    = this;
      var handles = Config.upsellHandles;
      if (!handles || !handles.length) {
        this.upsellSection.style.display = 'none';
        return;
      }

      // Hämta produkter i rätt ordning, hoppa över misslyckade
      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        self.upsellProducts = products.filter(Boolean);
        self._renderUpsells();
      });
    },

    _renderUpsells: function () {
      var self = this;

      if (!this.upsellProducts || !this.upsellProducts.length) {
        this.upsellSection.style.display = 'none';
        return;
      }

      this.upsellSection.style.display = '';
      this.upsellTrack.innerHTML        = '';
      this.upsellIndex = Math.min(this.upsellIndex, this.upsellProducts.length - 1);

      var tmpl = document.getElementById('upsell-card-template');

      this.upsellProducts.forEach(function (product) {
        var variant = product.variants[0];
        var node    = tmpl.content.cloneNode(true);
        var card    = node.querySelector('.upsell-card');

        // Bild
        var imgSrc = '';
        if (product.images && product.images.length) {
          imgSrc = product.images[0].src || product.images[0];
        }
        card.querySelector('.upsell-card__img').src = imgSrc;
        card.querySelector('.upsell-card__img').alt = product.title;

        // Titel
        card.querySelector('.upsell-card__title').textContent = product.title;

        // Pris
        card.querySelector('.upsell-card__price').textContent = formatMoney(variant.price);

        // Jämförpris
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var comp = card.querySelector('.upsell-card__compare');
          comp.textContent   = formatMoney(variant.compare_at_price);
          comp.style.display = '';
        }

        // Variant-selects
        var variantsWrap = card.querySelector('.upsell-card__variants');
        if (product.options && product.variants.length > 1) {
          product.options.forEach(function (option, optIdx) {
            // Hoppa över "Title"-option (standardoption för produkter utan varianter)
            if (option.name === 'Title') return;

            var row    = document.createElement('div');
            row.style.cssText = 'display:flex;align-items:center;gap:5px;';

            var label  = document.createElement('span');
            label.className   = 'upsell-card__variant-label';
            label.textContent = option.name + ':';

            var select = document.createElement('select');
            select.className = 'upsell-card__select';

            var values = [];
            product.variants.forEach(function (v) {
              var val = v['option' + (optIdx + 1)];
              if (val && values.indexOf(val) === -1) values.push(val);
            });

            values.forEach(function (val) {
              var opt = document.createElement('option');
              opt.value = val; opt.textContent = val;
              select.appendChild(opt);
            });

            row.appendChild(label);
            row.appendChild(select);
            variantsWrap.appendChild(row);
          });
        }

        // Lägg i varukorgen-knapp
        var addBtn = card.querySelector('.upsell-card__add-btn');
        addBtn.addEventListener('click', function () {
          // Hitta rätt variant baserat på valda options
          var allSelects   = variantsWrap.querySelectorAll('.upsell-card__select');
          var selectedOpts = Array.from(allSelects).map(function (s) { return s.value; });

          var matchedVariant;
          if (selectedOpts.length && product.options[0].name !== 'Title') {
            matchedVariant = product.variants.find(function (v) {
              return product.options.every(function (opt, i) {
                return opt.name === 'Title' || v['option' + (i + 1)] === selectedOpts[i];
              });
            });
          }
          var finalVariant = matchedVariant || variant;

          addBtn.textContent = '✓ Tillagd';
          addBtn.classList.add('added');

          self._addThenOpen(finalVariant.id, 1);

          setTimeout(function () {
            addBtn.textContent = 'Lägg i varukorgen';
            addBtn.classList.remove('added');
          }, 2500);
        });

        self.upsellTrack.appendChild(node);
      });

      this._applyUpsellSlide();

      // Visa/dölj pilar
      var show = this.upsellProducts.length > 1;
      document.getElementById('upsell-prev').style.display = show ? '' : 'none';
      document.getElementById('upsell-next').style.display = show ? '' : 'none';
    },

    _upsellTo: function (index) {
      var count = this.upsellProducts.length;
      if (!count) return;
      this.upsellIndex = (index + count) % count;
      this._applyUpsellSlide();
    },

    _applyUpsellSlide: function () {
      this.upsellTrack.style.transform = 'translateX(-' + (this.upsellIndex * 100) + '%)';
    },
  };

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { Drawer.init(); });
  } else {
    Drawer.init();
  }

  window.CartDrawer = Drawer;
})();